export const isTelegramOrder = (o) => o.source !== "landing" && Number(o.user_telegram_id || 0) > 0;

export function orderSource(o) {
  if (o.source === "test_seed") return "test";
  if (o.landing_topup) return "topup";                 // 💳 пополнение баланса
  if (o.source === "admin") return "admin";
  if (isTelegramOrder(o)) return o.source === "bot_simple" ? "tgs" : "tg";
  if (o.source === "landing") {
    if (o.landing_paid_from_balance) return "app_balance";  // ⚖️ оплата с баланса
    if (o.landing_mode === "app") return "app";              // 📱 мини-апп
    if (o.landing_mode === "bot") return "site2";            // 🌐 конструктор 2
    if (o.landing_mode === "studio") return "site1";         // 🌐 конструктор 1
    return "site";
  }
  return "other";
}

// День события считаем по Киеву — так же, как доход на бэкенде (Europe/Kyiv).
// Иначе при TZ браузера ≠ Киев карточки «заказы» и «доход» живут в разных днях.
const KYIV_DAY_FMT = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Europe/Kyiv",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const KYIV_HOUR_FMT = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Europe/Kyiv",
  hour: "2-digit",
  hour12: false,
});

export function localDayKey(value) {
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return "";
  return KYIV_DAY_FMT.format(d);
}

export function kyivHour(value) {
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return -1;
  return Number(KYIV_HOUR_FMT.format(d));
}

export function prevDayKey(dayKey) {
  const [y, m, d] = String(dayKey || "").split("-").map(Number);
  if (!y || !m || !d) return "";
  const dt = new Date(Date.UTC(y, m - 1, d - 1));
  return `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, "0")}-${String(dt.getUTCDate()).padStart(2, "0")}`;
}

export function fmtDateShort(iso) {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function fmtTimeShort(iso) {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

export function plural(n, one, few, many) {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return few;
  return many;
}

export function fmtMoney(n) {
  return `${Math.round(Number(n) || 0).toLocaleString("uk-UA")} ₴`;
}
